import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
/**
 * Panes hold the content of interactive tabs
 *
 * @return {jsx}
 */

var Panes = function Panes(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
Panes.propTypes = {
  /** Anything that can be rendered: numbers, strings, elements or an array (or fragment) */
  children: node.isRequired,

  /** className needed by styled components  */
  className: string
};
/**
 * Default props.
 */

Panes.defaultProps = {
  className: undefined
};
var StyledPanes = styled(Panes).withConfig({
  displayName: "Panes__StyledPanes",
  componentId: "l0i6yo-0"
})(["display:flex;width:100%;height:100%;"]);
StyledPanes.displayName = 'Panes';
export default StyledPanes;